import { render, staticRenderFns } from "./ColorSwapping.vue?vue&type=template&id=353fe352&scoped=true&"
import script from "./ColorSwapping.vue?vue&type=script&lang=js&"
export * from "./ColorSwapping.vue?vue&type=script&lang=js&"
import style0 from "./ColorSwapping.vue?vue&type=style&index=0&id=353fe352&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353fe352",
  null
  
)

export default component.exports